import React, { Component } from 'react';
import * as lib from '~/dependencies';
import AudioVisualiser from './AudioVisualiser';
import { PidsWrapper, BoxPids } from './styles';

class MicrophoneAudioAnalyzer extends Component {
  constructor(props) {
    super(props);
    this.state = { audioData: new Uint8Array(0) };
    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    const { audio } = this.props;

    if (audio) {
      this.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      this.analyser = this.audioContext.createAnalyser();
      this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
      this.source = this.audioContext.createMediaStreamSource(audio);
      this.source.connect(this.analyser);
      this.rafId = requestAnimationFrame(this.tick);
    }
  }

  componentDidUpdate(prevProps) {
    const { audio } = this.props;
    if (audio !== prevProps.audio) {
      if (audio) {
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
        this.analyser = this.audioContext.createAnalyser();
        this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
        this.source = this.audioContext.createMediaStreamSource(audio);
        this.source.connect(this.analyser);
        this.rafId = requestAnimationFrame(this.tick);
      }
    }
  }

  componentWillUnmount() {
    const { stopMicrophone } = this.props;

    cancelAnimationFrame(this.rafId);
    this.analyser.disconnect();
    this.source.disconnect();
    stopMicrophone();
  }

  tick() {
    this.analyser.getByteTimeDomainData(this.dataArray);
    this.setState({ audioData: this.dataArray });
    this.rafId = requestAnimationFrame(this.tick);
  }

  render() {
    const { audioData } = this.state;
    const { barColor } = this.props;
    return (
      <PidsWrapper>
        <BoxPids dashes>
          {Array.from({ length: 20 }, pidId => (
            <div key={pidId} className="pid" />
          ))}
        </BoxPids>

        <AudioVisualiser audioData={audioData} barColor={barColor} />
      </PidsWrapper>
    );
  }
}

MicrophoneAudioAnalyzer.defaultProps = {
  audio: [],
  stopMicrophone: () => {},
  barColor: '#2C4F9E',
};

MicrophoneAudioAnalyzer.propTypes = {
  audio: lib.PropTypes.instanceOf(Object),
  stopMicrophone: lib.PropTypes.func,
  barColor: lib.PropTypes.string,
};

export default MicrophoneAudioAnalyzer;
